import React from 'react';
import { SEO } from '../components/SEO';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      <SEO 
        title="Privacy Policy | Calspark Electrical & Engineers"
        description="Privacy Policy for Calspark Electrical & Engineers. Learn how we collect, use, and protect your personal information."
        ogUrl="/privacy-policy"
      />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-800 to-slate-900 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Privacy Policy</h1>
          <p className="text-lg text-slate-300">Calspark Electrical & Engineers</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-slate-500 mb-8 text-base">Last updated: June 2025</p>
            
            <p className="text-slate-700 text-lg leading-relaxed mb-8">
              Calspark Electrical & Engineers ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website calsparkengineers.com.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Information We Collect</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              We may collect the following information when you fill out our contact or enquiry forms: your name, email address, phone number, and project details.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-3 text-slate-700 text-lg mb-6">
              <li>To respond to your enquiries and project requests</li>
              <li>To send relevant information about our services</li>
              <li>To improve our website and services</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Data Security</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              We are committed to ensuring that your information is secure. We do not sell, trade, or transfer your personally identifiable information to outside parties.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Third Party Links</h2>
            <p className="text-slate-700 text-lg leading-relaxed mb-6">
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of those sites.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-4">Contact Us</h2>
            <p className="text-slate-700 text-lg leading-relaxed">
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:enquiry@calsparkengineers.com" className="text-teal-600 hover:text-teal-700 font-medium">
                enquiry@calsparkengineers.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
